export const trimTypeConstants = {
  GET_SINGLE_REQUEST: "TRIMTYPE_GET_SINGLE_REQUEST",
  GET_SINGLE_SUCCESS: "TRIMTYPE_GET_SINGLE_SUCCESS",
  GET_SINGLE_FAILURE: "TRIMTYPE_GET_SINGLE_FAILURE",

  GET_ALL_REQUEST: "TRIMTYPE_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "TRIMTYPE_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "TRIMTYPE_GET_ALL_FAILURE",

  ADD_REQUEST: "TRIMTYPE_ADD_REQUEST",
  ADD_SUCCESS: "TRIMTYPE_ADD_SUCCESS",
  ADD_FAILURE: "TRIMTYPE_ADD_FAILURE",

  UPDATE_REQUEST: "TRIMTYPE_UPDATE_REQUEST",
  UPDATE_SUCCESS: "TRIMTYPE_UPDATE_SUCCESS",
  UPDATE_FAILURE: "TRIMTYPE_UPDATE_FAILURE",

  DELETE_REQUEST: "TRIMTYPE_DELETE_REQUEST",
  DELETE_SUCCESS: "TRIMTYPE_DELETE_SUCCESS",
  DELETE_FAILURE: "TRIMTYPE_DELETE_FAILURE",

  CLEAR: "TRIMTYPE_CLEAR",
};
